cb.define(['common/common_VM.Extend.js'], function (common) {

    var PM_pmc_combinationsaleslist_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {

            var gridModel = viewmodel.getGridModel();

            viewmodel.on('beforeEdit', function (args) {
                return common.checkAuth(args.carry.rowData.id, 'pmc_combinationsales');
            })

            gridModel.on('afterSetDataSource', () => {
                const rows = gridModel.getRows();
                const actions = gridModel.getCache('actions');
                const actionsStates = [];
                rows.forEach(data => {
                    const actionState = {};
                    actions.forEach(action => {
                        if (action.cItemName == "btnDisAble") {

                            if (data.valid == 0) {
                                actionState[action.cItemName] = {visible: false};
                            } else {
                                actionState[action.cItemName] = {visible: true};
                            }
                        } else if (action.cItemName == "btnEnAble") {
                            if (data.valid == 0) {
                                actionState[action.cItemName] = {visible: true};
                            } else {
                                actionState[action.cItemName] = {visible: false};
                            }
                        } else {
                            actionState[action.cItemName] = {visible: true};
                        }
                    });
                    actionsStates.push(actionState);
                });
                gridModel.setActionsState(actionsStates);
            });
        }
    };
    try {
        module.exports = PM_pmc_combinationsaleslist_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_combinationsaleslist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_combinationsaleslist_VM.Extend.js